import React from "react";
import useStyles from '../Elements/Styles';
import formats from '../Elements/formats.json'
import {convertDate, formatBytes, toAbsoluteUrl} from "helpers/fileManager";
import {Draggable, Droppable} from "react-beautiful-dnd";
import {
    Box,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip
} from "@material-ui/core";
import clsx from "clsx";
import {useDispatch, useSelector} from "react-redux";
import {attachedFiles} from "redux/actions/fileManager";
import {setFileManagerDialog} from "redux/actions/inbox";
import {SERVER_PATH} from "assets/constants";

export default function ViewItems({onContextMenuClick, addSelect, doubleClick }){
    const classes = useStyles();
    const dispatch = useDispatch();

    const {itemsView, showImages, bufferedItems, selectedFiles, filesList} = useSelector(store => store.fileManager);

    const getThumb = (item) => {
        try {
            if(showImages === 'thumbs' && formats.imageFiles.includes(item.extension)){
                return `${SERVER_PATH}${item.path}`
            } else {
                return typeof formats.icons[item.extension] !== 'undefined' ? toAbsoluteUrl(formats.icons[item.extension]) : toAbsoluteUrl(formats.icons.broken)
            }
        }catch (e) {
            return toAbsoluteUrl(formats.icons.broken);
        }
    }

    const handleContextMenuClick = async (item,event) => {
        addSelect(item);
        onContextMenuClick(event);
    }

    const handleDoubleClick = (item) => {
        dispatch(attachedFiles([item]));
        dispatch(setFileManagerDialog(false))
    };

    const checkIsSelected = item => {
        return selectedFiles.includes(item);
    }

    const isCuted = item => {
        if(bufferedItems.type === 'cut'){
            return  bufferedItems.files.filter((file) => file.id === item.id).length > 0;
        }
        return false;
    }

    function getStyle(style, snapshot) {
        if (!snapshot.isDraggingOver) {
            return style;
        }
        return {
            ...style,
            background:'#f00 !important',
        };
    };

    const FileItem = ({item,index}) => {
        let fileCuted = isCuted(item);
        let isSelected = checkIsSelected(item);

        return(
            <Draggable
                draggableId={item.id}
                index={index}
                isDragDisabled={item.private}
            >
                {(provided, snapshot)=>(
                    <Box
                        onContextMenu={(event)=>handleContextMenuClick(item,event)}
                        className={clsx(
                            classes.itemFile,
                            {
                                "selected": selectedFiles.includes(item.path),
                                "selectmode": selectedFiles.length > 0,
                                "notDragging": !snapshot.isDragging,
                                'fileCuted': fileCuted
                            })
                        }
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        { (item.private && <span className={`icon-lock ${classes.locked}`}/>) ||
                        <Checkbox className={classes.checkbox} checked={isSelected} onChange={()=>addSelect(item)} value={item.id} />
                        }
                        <span className={classes.extension}>{item.extension}</span>

                        <div className={classes.infoBox}
                             onDoubleClick={()=>handleDoubleClick(item)}>
                            <img src={getThumb(item)} alt='item thumbs'/>
                        </div>
                        <Tooltip title={item.name}>
                            <div className={classes.itemTitle}>
                                <span>{item.name}</span>
                            </div>
                        </Tooltip>

                    </Box>
                )}
            </Draggable>
        );
    };

    const FolderItem = ({item,index}) => {
        let fileCuted = isCuted(item);
        let isSelected = checkIsSelected(item);
        return(
            <Draggable
                index={index}
                draggableId={item.id}
                isDragDisabled={item.private}

            >
                {(provided, snapshot)=>(
                    <Box
                        ref={provided.innerRef}
                        className={clsx(
                            classes.itemFile,
                            {
                                "selected": selectedFiles.includes(item.path),
                                "selectmode": selectedFiles.length > 0,
                                "notDragging": !snapshot.isDragging,
                                'fileCuted': fileCuted
                            })
                        }
                        onDoubleClick={()=>doubleClick(item.path)}
                        onContextMenu={(event)=>handleContextMenuClick(item,event)}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <Droppable droppableId={item.id} type="CONTAINERITEM" isCombineEnabled>
                            {(provided, snapshot) => (
                                <div
                                    ref={provided.innerRef}
                                    {...provided.droppableProps}
                                    style={getStyle(provided.droppableProps.style, snapshot)}
                                >
                                    { (item.private && <span className={`icon-lock ${classes.locked}`}/>) ||
                                    <Checkbox className={classes.checkbox} checked={isSelected} onChange={()=>addSelect(item)} value={item.id} />
                                    }
                                    <div className={classes.infoBox}>
                                        <img alt='info box' src={snapshot.isDraggingOver ? toAbsoluteUrl(formats.icons.folderopen) : toAbsoluteUrl(formats.icons.folder) } />
                                    </div>
                                    <Tooltip title={ <>
                                        <b>Name :</b> {item.name} <br />
                                        <b>Created :</b> {convertDate(item.created)}
                                    </>
                                    }>
                                        <div className={classes.itemTitle}>
                                            <span>{item.name}</span>
                                        </div>
                                    </Tooltip>
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </Box>
                )}
            </Draggable>
        );
    }

    const ListFolderItem = ({item,index})=>{
        let fileCuted = isCuted(item);
        let isSelected = checkIsSelected(item);

        return (
            <Draggable index={index} draggableId={item.id}>
                {(provided, snapshot)=>(
                    <TableRow
                        ref={provided.innerRef}
                        className={clsx(
                            classes.tableListRow,
                            {
                                "selected": selectedFiles.includes(item.path),
                                'fileCuted': fileCuted,
                                "selectmodeTable": selectedFiles.length > 0
                            })
                        }
                        onDoubleClick={()=>doubleClick(item.path)}
                        onContextMenu={(event)=>handleContextMenuClick(item,event)}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <Droppable droppableId={item.id} type="CONTAINERITEM" isCombineEnabled>
                            {(provided, snapshot) => (
                                <>
                                    <TableCell className={classes.tableCell}><Checkbox checked={isSelected} onChange={()=>addSelect(item)} value={item.id} /></TableCell>
                                    <TableCell className={classes.tableCell}><img alt='drag & drop' style={{"width":"20px"}} src={snapshot.isDraggingOver ? toAbsoluteUrl(formats.icons.folderopen) : toAbsoluteUrl(formats.icons.folder) } /></TableCell>
                                    <TableCell className={classes.tableCell} align="left">
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={getStyle(provided.droppableProps.style, snapshot)}
                                        >
                                            {item.name}
                                            {provided.placeholder}
                                        </div>
                                    </TableCell>
                                    <TableCell className={classes.tableCell} align="left">{formatBytes(item.size)}</TableCell>
                                    <TableCell className={classes.tableCell} align="left">{convertDate(item.created)}</TableCell>
                                </>
                            )}
                        </Droppable>
                    </TableRow>
                )}
            </Draggable>
        );
    }

    const ListFileItem = ({item,index})=>{
        let fileCuted = isCuted(item);
        let isSelected = checkIsSelected(item);

        return (
            <Draggable
                draggableId={item.id}
                index={index}
            >
                {(provided, snapshot)=>(
                    <TableRow
                        onContextMenu={(event)=>handleContextMenuClick(item,event)}
                        className={clsx(
                            classes.tableListRow,
                            {
                                "selected": selectedFiles.includes(item.path),
                                'fileCuted': fileCuted,
                                "selectmodeTable": selectedFiles.length > 0
                            })
                        }
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                    >
                        <TableCell className={classes.tableCell}>
                            <Checkbox checked={isSelected} onChange={()=>addSelect(item)} value={item.id} />
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <img alt='list file item' style={{"width":"20px", 'maxHeight': '30px'}} src={getThumb(item)} />
                        </TableCell>
                        <TableCell className={classes.tableCell}
                                   onDoubleClick={()=> handleDoubleClick(item)}
                                   align="left">{item.name}</TableCell>
                        <TableCell className={classes.tableCell} align="left">{formatBytes(item.size)}</TableCell>
                        <TableCell className={classes.tableCell} align="left">{convertDate(item.created)}</TableCell>
                    </TableRow>
                )}
            </Draggable>
        );
    };

    const ListView = () => {
        return(
            <TableContainer component={Box}>
                <Table className={classes.table} size="small" aria-label="a dense table">

                    <TableHead>
                        <TableRow className={classes.tableHead}>
                            <TableCell style={{"width": '20px'}}></TableCell>
                            <TableCell style={{"width": '35px'}} align="left"></TableCell>
                            <TableCell align="left">Name</TableCell>
                            <TableCell style={{"width": '100px'}} align="left">Size</TableCell>
                            <TableCell style={{"width": '150px'}} align="left">Created</TableCell>
                        </TableRow>
                    </TableHead>

                    <Droppable droppableId="listDroppablContainer" type="CONTAINERITEM" isCombineEnabled>
                        {(provided, snapshot) => (
                            <TableBody ref={provided.innerRef} {...provided.droppableProps} >

                                {filesList.map((item,index) => (
                                    item.type === 'folder' && <ListFolderItem key={index} index={index} item={item} />
                                ))}

                                {filesList.map((item,index) => (
                                    item.type === 'file' && <ListFileItem key={index} index={index} item={item} />
                                ))}

                                {provided.placeholder}
                            </TableBody>
                        )}
                    </Droppable>
                </Table>
                { filesList.length === 0 && <div style={{ display: 'flex', justifyContent: 'center'}}> Please Upload Files </div> }
            </TableContainer>
        )
    };

    const GridView = () => {
        return (
            <div className={classes.itemsList}>

                <Droppable droppableId="mainDroppablContainer" type="CONTAINERITEM" isCombineEnabled>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                        >
                            {filesList.map((item,index) => (
                                item.type === 'folder' && <FolderItem  key={index} index={index} item={item} />
                            ))}

                            {filesList.map((item,index) => (
                                item.type === 'file' && <FileItem  key={index} index={index} item={item} />
                            ))}

                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
                { filesList.length === 0 && <div style={{ display: 'flex', justifyContent: 'center'}}> Please Upload Files </div> }
            </div>
        )
    }

    return (
        <>
            {itemsView === 'grid' ? <GridView/> : <ListView/>}
        </>
    )
}